let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6c5on")).then(() => parcelRequire('gSGR3'));